<div
  *ngIf="auth.featureFlags.showMenuLHS"
  class="menu-aside"
  [class.asidetxt]="!asidetxt"
>
  <div class="contop">
    <div
      class="news"
      *ngIf="
        auth.featureFlags.showNewsLab &&
        (user?.groups?.includes('SUBSCRIPTION_ALL') ||
          user?.roles?.includes('SUBSCRIPTION_ALL') ||
          user?.groups?.includes('SUBSCRIPTION_NEWS') ||
          user?.roles?.includes('SUBSCRIPTION_NEWS'))
      "
    >
      <div class="tito">News</div>
      <div
        *ngIf="auth.featureFlags.showPortfolio"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Portfolio"
        matTooltipPosition="right"
        routerLink="news/portfolio"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          flagevent: null,
          tag: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon>collections_bookmark</mat-icon>
        <span class="txt">Portfolio</span>
      </div>
      <div
        *ngIf="auth.featureFlags.showCollection"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Collection"
        matTooltipPosition="right"
        routerLink="news/query"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          flagevent: null,
          tag: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon>view_module</mat-icon>
        <span class="txt">Collection</span>
      </div>
      <div
        *ngIf="
          auth.featureFlags.showChatLLM || user?.email?.includes('@yukkalab')
        "
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Chat"
        matTooltipPosition="right"
        routerLink="chat"
        routerLinkActive="active"
      >
        <mat-icon>chat_question</mat-icon>
        <span class="txt">Chat</span>
      </div>
    </div>
    <div
      class="trend"
      *ngIf="
        auth.featureFlags.showInvestLab &&
        (user?.groups?.includes('SUBSCRIPTION_ALL') ||
          user?.roles?.includes('SUBSCRIPTION_ALL') ||
          user?.groups?.includes('SUBSCRIPTION_TREND') ||
          user?.roles?.includes('SUBSCRIPTION_TREND'))
      "
    >
      <div
        class="space"
        *ngIf="
          user?.groups?.includes('SUBSCRIPTION_ALL') ||
          user?.roles?.includes('SUBSCRIPTION_ALL')
        "
      ></div>
      <div class="tito">Invest</div>

      <div
        *ngIf="auth.featureFlags.showSignals"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Signals"
        matTooltipPosition="right"
        routerLink="invest/signal"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          flagevent: null,
          tag: null,
          newstype: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon svgIcon="chart-areaspline"></mat-icon>
        <span class="txt">Signals</span>
      </div>
      <div
        *ngIf="auth.featureFlags.showTrending"
        class="mainmenu"
        [class.light]="routing.theme === 'light'"
        matTooltip="Trending"
        matTooltipPosition="right"
        routerLink="invest/trending"
        routerLinkActive="active"
        [queryParams]="{
          id: null,
          eventid: null,
          eventype: null,
          scoreevent: null,
          flagevent: null,
          tag: null,
          newstype: null,
        }"
        queryParamsHandling="merge"
      >
        <mat-icon>whatshot</mat-icon>
        <span class="txt">Trending</span>
      </div>

      <div class="space"></div>
    </div>
  </div>
  <div class="conbot" *ngIf="auth.featureFlags.showUserLab">
    <div class="space"></div>
    <div class="tito">User</div>

    <div
      id="show-user-menu-account"
      *ngIf="auth.featureFlags.showMenuAccount"
      class="mainmenu"
      [class.light]="routing.theme === 'light'"
      matTooltip="Account"
      matTooltipPosition="right"
      [routerLink]="[]"
      [queryParams]="{
        sidenav: params.sidenav === 'account' ? null : 'account',
        reflow: params.reflow === 'true' ? null : 'true',
      }"
      queryParamsHandling="merge"
    >
      <mat-icon>person</mat-icon>
      <span class="txt">Account</span>
    </div>
    <div
      id="score-settings"
      *ngIf="auth.featureFlags.showSettings"
      class="mainmenu"
      [class.light]="routing.theme === 'light'"
      matTooltip="Scores"
      matTooltipPosition="right"
      (click)="openSettings()"
    >
      <span class="scores-icon">
        <svg-icon src="assets/icon/scores.svg"></svg-icon>
      </span>
      <span class="txt">Scores</span>
    </div>
    <div
      id="flags-settings"
      *ngIf="auth.featureFlags.showFlagsSetup"
      class="mainmenu"
      [class.light]="routing.theme === 'light'"
      matTooltip="Flags"
      matTooltipPosition="right"
      (click)="openFlags()"
    >
      <mat-icon>flag</mat-icon>
      <span class="txt">Flags</span>
    </div>
    <div
      *ngIf="auth.featureFlags.showNewsletter"
      class="mainmenu"
      [class.light]="routing.theme === 'light'"
      matTooltip="Newsletter"
      matTooltipPosition="right"
      routerLink="newsletter"
      routerLinkActive="active"
      [queryParams]="{
        id: null,
        eventid: null,
        eventype: null,
        scoreevent: null,
        flagevent: null,
        tag: null,
      }"
      queryParamsHandling="merge"
    >
      <mat-icon>email</mat-icon>
      <span class="txt">Newsletter</span>
    </div>
    <div
      id="alert-settings"
      *ngIf="auth.featureFlags.showAlertsSetup"
      class="mainmenu"
      [class.light]="routing.theme === 'light'"
      matTooltip="Alerts"
      matTooltipPosition="right"
      (click)="openAlerts()"
      [style.opacity]="eventsList ? 1 : 0.5"
      [style.cursor]="eventsList ? 'pointer' : 'wait'"
    >
      <mat-icon>notifications</mat-icon>
      <span class="txt">Alerts</span>
    </div>

    <div
      *ngIf="auth.featureFlags.showExpand"
      class="btnmenu"
      [routerLink]="[]"
      [queryParams]="{ reflow: params.reflow === 'true' ? null : 'true' }"
      queryParamsHandling="merge"
      (click)="myAsidetxt()"
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </div>
  </div>
</div>
